import honorImage1 from '@/assets/images/news/honor/honor1.png';
import honorImage2 from '@/assets/images/news/honor/honor2.png';
import honorImage3 from '@/assets/images/news/honor/honor3.png';
import honorImage4 from '@/assets/images/news/honor/honor4.png';
import honorImage5 from '@/assets/images/news/honor/honor5.png';
import honorImage6 from '@/assets/images/news/honor/honor6.png';
import honorImage7 from '@/assets/images/news/honor/honor7.png';
import honorImage8 from '@/assets/images/news/honor/honor8.png';
import honorImage9 from '@/assets/images/news/honor/honor9.png';
import honorImage10 from '@/assets/images/news/honor/honor10.png';
import honorImage11 from '@/assets/images/news/honor/honor11.png';
import honorImage12 from '@/assets/images/news/honor/honor12.png';
import honorImage13 from '@/assets/images/news/honor/honor13.png';
import honorImage14 from '@/assets/images/news/honor/honor14.png';
import honorImage15 from '@/assets/images/news/honor/honor15.png';
import honorImage16 from '@/assets/images/news/honor/honor16.png';
import honorImage17 from '@/assets/images/news/honor/honor17.png';
import honorImage18 from '@/assets/images/news/honor/honor18.png';
import honorImage19 from '@/assets/images/news/honor/honor19.png';
import honorImage20 from '@/assets/images/news/honor/honor20.png';
import honorImage21 from '@/assets/images/news/honor/honor21.png';
import honorImage22 from '@/assets/images/news/honor/honor22.png';

export const carouselData: Array<any> = [
  [
    {
      title: '上海市五一劳动奖状',
      image: honorImage17,
    },
    {
      title: '先进基层党组织',
      image: honorImage18,
    },
    {
      title: '2020年上海在线新经济年度人物——梁昌霖',
      image: honorImage19,
    },
    {
      title: '浦东新区农业产业化龙头企业',
      image: honorImage20,
    },
    {
      title: '上海市2020年放心消费创建优秀单位',
      image: honorImage21,
    },
    {
      title: '2017-2020年度上海市助力脱贫攻坚先进集体',
      image: honorImage22,
    },
    {
      title: 'X时代年度影响力电商平台',
      image: honorImage1,
    },
    {
      title: '中国社区商业琅琊榜2019年度瞪羚连锁品牌',
      image: honorImage2,
    },
  ],
  [
    {
      title: '行业创领品牌',
      image: honorImage3,
    },
    {
      title: '2018年度浦东新区创新创业奖',
      image: honorImage4,
    },
    {
      title: '2020浦东电商“抗击疫情、保障民生”突出贡献奖',
      image: honorImage5,
    },
    {
      title: '2018-2019年度上海市电子商务示范企业',
      image: honorImage6,
    },
    {
      title: '拥军优属支持单位',
      image: honorImage7,
    },
    {
      title: '上海电商扶贫优秀案例',
      image: honorImage8,
    },
    {
      title: '上海市单用途预付卡行业“抗疫奉献”标兵企业',
      image: honorImage9,
    },
    {
      title: '上海市物流协会冷链分会常务理事单位',
      image: honorImage10,
    },
  ],
  [
    {
      title: '上海市“最美退役军人”——梁昌霖',
      image: honorImage11,
    },
    {
      title: '沪遵消费扶贫产销对接特别贡献奖',
      image: honorImage12,
    },
    {
      title: '上海市浦东新区企业研发机构证书',
      image: honorImage13,
    },
    {
      title: '中华人民共和国商务部办公厅感谢信',
      image: honorImage14,
    },
    {
      title: '浦东新区企业社会责任达标企业',
      image: honorImage15,
    },
    {
      title: '优质农产品供应链创新服务企业',
      image: honorImage16,
    },
  ],
];
